import project2 from './img/project/project2.jpg';
import project3 from './img/project/project3.jpg';
import project4 from './img/project/project4.jpg';
import project5 from './img/project/project5.jpg';
import project6 from './img/project/project6.jpg';
import project7 from './img/project/project7.jpg';
import project8 from './img/project/project8.jpg';

export const products = [
    {
      id: 1,
      img: project2,
      link: "http://lama.dev",
    },
    {
      id: 2,
      img: project3,
      link: "http://lama.dev",
    },
    {
      id: 3,
      img: project4,
      link: "http://lama.dev",
    },
    {
      id: 4,
      img: project8,
      link: "http://lama.dev",
    },
    {
      id: 5,
      img: project6,
      link: "http://lama.dev",
    },
    {
      id: 6,
      img: project7,
      link: "http://lama.dev",
    },
  ];